import { Component, OnInit, Input } from '@angular/core';
import { Category } from './category.model';

@Component({
    selector: 'ef-category',
    templateUrl: './category.component.html',
    styleUrls: ['./category.component.scss'],
    standalone: false
})
export class CategoryComponent implements OnInit {
    @Input() public category: Category;
    constructor() {}

    ngOnInit() {}

}
